import { render, staticRenderFns } from "./stepOne.vue?vue&type=template&id=2ffba0bd&scoped=true&"
import script from "./stepOne.vue?vue&type=script&lang=js&"
export * from "./stepOne.vue?vue&type=script&lang=js&"
import style0 from "./stepOne.vue?vue&type=style&index=0&id=2ffba0bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffba0bd",
  null
  
)

export default component.exports